export default __webpack_public_path__ + "static/media/Flecha_blue.b81ca8d4.svg";